import * as Cesium from "cesium";

// invertDeletion is used to remove only lines associated with the entityId
// (if false it removes everything apart from the entityId)
export const clearLines = (viewer: Cesium.Viewer, entityId?: string, invertDeletion?: boolean) => {
	const entitiesToBeRemoved: Cesium.Entity[] = [];

	viewer.entities.values.forEach((entity) => {
		if (
			entity.id.includes("line") &&
			entityId !== undefined &&
			(!invertDeletion ? !entity.id.includes(`line-${entityId}`) : entity.id.includes(`line-${entityId}`))
		) {
			entitiesToBeRemoved.push(entity);
		} else if (entity.id.includes("line") && entityId === undefined) {
			entitiesToBeRemoved.push(entity);
		}
	});

	entitiesToBeRemoved.forEach((entity) => viewer.entities.remove(entity));
};
